import { Outlet } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import AnalyticsTracker from "@/components/common/AnalyticsTracker";
import WhatsAppButton from "@/components/common/WhatsAppButton";
import SEO from "@/components/common/SEO";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";
import { siteDefaultMeta } from "@/lib/seoMeta";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const { settings } = useSettings();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEO {...siteDefaultMeta(settings, pathname)} />
      <AnalyticsTracker />
      <Header />
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
